import styled, { css } from "styled-components";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_M, ZIndex } from "@src/common/styles/const";
import { media } from "@src/common/styles/mixins";
import { ReactComponent as ChevronRight } from "@src/modules/DeviceStatus/Devices/DeviceInfoView/icons/chevron-right.svg";
import {
  Background,
  MODAL_TRANSITION_TIME_MS,
} from "@src/modules/shared/components/Modal/ModalContainer.components";

const SIDEBAR_WIDTH = 350;
export const TOGGLE_SIDEBAR_BUTTON_WIDTH = 48;
const DEVICE_ICON_MARGIN = 400;
const DEVICE_ICON_WRAPPER_SIZE = 40;

export const SidebarWrapper = styled.div<{ isOpened?: boolean }>`
  width: ${SIDEBAR_WIDTH}px;
  padding: ${DEFAULT_MARGIN_M}px;
  background-color: ${colors.gray1};

  ${media.only("TABLET")`
    position: absolute;
    z-index: ${ZIndex.ModalBackgroundShowHeader + 1};
    height: 100%;
    transition: left ${MODAL_TRANSITION_TIME_MS}ms;
    overflow-y: auto;
  `}

  ${media.down("MOBILE")`
    width: 100%;
    z-index: ${ZIndex.ModalBackgroundShowHeader + 1};
  `}

  ${(p) =>
    p.isOpened &&
    css`
      ${media.only("TABLET")`
        left: 0;
      `}
    `}

  ${(p) =>
    !p.isOpened &&
    css`
      ${media.only("TABLET")`
        left: -${SIDEBAR_WIDTH}px;
      `}
    `}
`;

export const ToggleSidebarTabletButton = styled.button<{
  $isSidebarOpened?: boolean;
}>`
  position: absolute;
  left: ${(p) => (p.$isSidebarOpened ? SIDEBAR_WIDTH : 0)}px;
  transition: left ${MODAL_TRANSITION_TIME_MS}ms;
  z-index: ${ZIndex.ModalBackgroundShowHeader + 1};

  display: flex;
  flex-direction: column;
  align-items: center;

  height: 100%;
  width: ${TOGGLE_SIDEBAR_BUTTON_WIDTH}px;
  background: ${colors.gray1};
  border: 1px solid transparent;
  border-right-color: ${colors.gray2_5};
  padding-top: ${DEFAULT_MARGIN_M}px;

  ${(p) =>
    p.$isSidebarOpened &&
    css`
      border-left-color: ${colors.gray2_5};
    `}
`;

export const ToggleSidebarTabletArrow = styled(ChevronRight)<{
  $isSidebarOpened?: boolean;
}>`
  margin-top: ${DEVICE_ICON_MARGIN}px;

  ${(p) =>
    p.$isSidebarOpened &&
    css`
      margin-top: ${DEVICE_ICON_MARGIN + DEVICE_ICON_WRAPPER_SIZE}px;
      transform: rotate(180deg);
    `}
`;

export const TabletDeviceIconWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 3.075px;
  padding: 1.7px;
  width: ${DEVICE_ICON_WRAPPER_SIZE}px;
  height: ${DEVICE_ICON_WRAPPER_SIZE}px;
`;

export const TabletDeviceIcon = styled.img`
  object-fit: cover;
  height: 100%;
`;

export const ToggleSidebarMobileButton = styled.button`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.gray1};
  border: 1px solid ${colors.gray2_5};
  position: relative;
  z-index: ${ZIndex.ModalBackgroundShowHeader + 1};
`;

type ArrowDirection = "up" | "right" | "down" | "left";

export const ChevronArrow = styled(ChevronRight)<{ direction: ArrowDirection }>`
  transform: rotate(
    ${(p) =>
      p.direction === "up"
        ? -90
        : p.direction === "down"
        ? 90
        : p.direction === "left"
        ? 180
        : 0}deg
  );
`;

export const SidebarBackground = styled(Background)`
  visibility: hidden;
  transition: opacity ${MODAL_TRANSITION_TIME_MS}ms ease-in-out,
    visibility 0ms ease-in-out ${MODAL_TRANSITION_TIME_MS}ms;

  ${(p) =>
    p.status === "entered" &&
    css`
      visibility: visible;
      transition: opacity ${MODAL_TRANSITION_TIME_MS}ms ease-in-out,
        visibility 0ms ease-in-out 0ms;
    `}
`;
